'use client';
import { cn } from '@/app/lib/utils';
import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react';

export default function Pagination(Prop: {
  currentPage: number;
  setCurrentPage: any;
  totalPages: number;
  paginationId?: string;
}) {
  const {currentPage, setCurrentPage, totalPages} = Prop;
  const scollDist = 150;
  const [pageArray, setPageArray] = useState<number[]>([1]);
  const [toScroll, setScroll] = useState(false);
  const hasPreviousPage = useMemo(() => {
    return currentPage > 1;
  }, [currentPage]);
  const hasNextPage = useMemo(() => {
    return currentPage < totalPages;
  }, [currentPage, totalPages]);

  const formPageArray = (
    currentPage: number,
    totalPages: number,
    setPageArray: Dispatch<SetStateAction<number[]>>
  ) => {
    const tempPageArray = [1]; // 1
    if (currentPage > 3) {
      tempPageArray.push(-1); // ... sign
    }

    if (currentPage > 2) {
      tempPageArray.push(currentPage - 1); // prev page
    }

    if (currentPage != 1 && currentPage != totalPages) {
      tempPageArray.push(currentPage); // current page
    }

    if (currentPage + 1 < totalPages) {
      tempPageArray.push(currentPage + 1); // next page
    }
    if (currentPage + 1 < totalPages - 1) {
      tempPageArray.push(-1); // ... sign
    }

    if (totalPages > 1) {
      tempPageArray.push(totalPages); // max page
    }
    setPageArray(tempPageArray);
    if (toScroll) {
      handleScroll();
      setScroll(false);
    }
  };

  useEffect(() => {
    formPageArray(currentPage, totalPages, setPageArray);
  }, [currentPage, totalPages]);

  const handleScroll = () => {
    let found = false;
    if (Prop.paginationId) {
      const pagination = document.getElementById(Prop.paginationId);
      if (pagination) {
        const top =
          pagination.getBoundingClientRect().top + window.scrollY - scollDist;
        window.scrollTo({top: top, behavior: 'smooth'});
        found = true;
      }
    }
    if (!found) {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  };

  return (
    <div>
      {
        <div className="flex justify-center my-10 items-center ">
          <span
            onClick={() => {
              if (hasPreviousPage) {
                setScroll(true);
                setCurrentPage(currentPage - 1);
              }
            }}
            className={cn(
              'material-symbols outlined',
              hasPreviousPage
                ? 'cursor-pointer hover:text-[#e31836]'
                : 'cursor-not-allowed '
            )}
          >
            arrow_back_ios_new
          </span>
          {pageArray.map((page, index) => (
            <button
              key={index}
              onClick={() => {
                if (page != -1) {
                  setScroll(true);
                  setCurrentPage(page);
                }
              }}
              className={cn(
                ' mx-2 rounded-full text-center',
                page === -1 ? 'bg-white text-gray-600 cursor-default' : '',
                page === currentPage
                  ? 'w-10 h-10 bg-[#e31836] text-white'
                  : page != -1 &&
                      'bg-white text-gray-500 hover:text-[#e31836] hover:font-bold w-5'
              )}
            >
              {page === -1 ? '...' : page}
            </button>
          ))}
          <span
            onClick={() => {
              if (hasNextPage) {
                setScroll(true);
                setCurrentPage(currentPage + 1);
              }
            }}
            className={cn(
              'material-symbols outlined opacity-50 ',
              hasNextPage
                ? 'cursor-pointer hover:opacity-100 hover:text-[#e31836]'
                : 'cursor-not-allowed '
            )}
          >
            arrow_forward_ios
          </span>
        </div>
      }
    </div>
  );
}
